/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
import { VueEditor } from "vue2-editor";

export default {
  name: 'add-topic',
  components: {
    VueEditor
  },
  props: ['sectionIdForTopicID'],
  data() {
    return {
      section: "",
      file: null,
      name: '',
      SectionName: '',
      description: '',
      submitted: false,
      uploadFileName: '',
      uploadFileNameLowercase: '',
      section: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getcourseSectionByIDDataState'
    ]),
    getCourseSectionDataByID() {
      this.$store.dispatch('get_course_section_fun', {
        id: this.sectionIdForTopicID
      }).then((res) => {
        this.SectionName = this.$store.getters.getcourseSectionByIDDataState.data.name;
        this.uploadFileNameLowercase = this.SectionName.toLowerCase();
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCourseSectionDataByID
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('add_topic_desc',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['add_topic_desc'].on('change', () => {
        var content1Length = CKEDITOR.instances['add_topic_desc'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #add_topic_desc').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #add_topic_desc').removeClass('is-invalid')
          this.description = CKEDITOR.instances['add_topic_desc'].getData()
        }else{
          $('.custom_editor_for_option #add_topic_desc').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #add_topic_desc').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('HideAddNewFilePopup', false)
      }).catch((err) => {})
    },
    validateSectionBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let formData = new FormData();
          formData.append('section', this.sectionIdForTopicID);
          formData.append('name', this.name);
          formData.append('description', this.description);
          this.$store.dispatch('create_topic', formData)
            .then((res) => {
              this.getCourseDetailsAgain();
              this.name = '';
              this.description = '';
              toast.success(res.data.msg);
              bus.$emit('HideAddNewTopicPopup', false)
              this.$validator.reset();
            })
            .catch((err) => {})
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideAddNewTopicPopup', false)
    },
  },
  watch: {
  }
}